import React, { useState } from 'react';
import './GallerySection.css';

const galleryImages = [
  'galleryImage1.jpeg','galleryImage2.jpeg','galleryImage3.jpeg','galleryImage4.jpeg','galleryImage5.jpeg','galleryImage6.jpeg','galleryImage7.jpeg','galleryImage8.jpeg','galleryImage9.jpeg'
];

const GalleryModal = ({ open, src, onClose }) => {
  if (!open) return null;
  return (
    <div className="gallery-modal-overlay" onClick={onClose}>
      <div className="gallery-modal-content" onClick={e => e.stopPropagation()}>
        <button className="gallery-modal-close" onClick={onClose}>&times;</button>
        <img src={src} alt="Full view" className="gallery-modal-img" />
      </div>
    </div>
  );
};

const GallerySection = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImg, setModalImg] = useState(null);

  const openModal = (img) => {
    setModalImg(`/Gallery/${img}`);
    setModalOpen(true);
  };

  return (
    <section className="homepage-gallery-section">
      <h1 className="homepage-gallery-title">Our Gallery</h1>
      <p className="homepage-gallery-desc">Explore our curated collection of stunning images that showcase the beauty and creativity of our work.</p>
      <div className="homepage-gallery-grid">
        {galleryImages.map((img, idx) => (
          <div className="homepage-gallery-item" key={img}>
            <img src={`/Gallery/${img}`} alt={`Gallery ${idx+1}`} className="homepage-gallery-img" onClick={() => openModal(img)} style={{cursor:'pointer'}} />
            <div className="homepage-gallery-overlay" onClick={() => openModal(img)} style={{cursor:'pointer'}}></div>
          </div>
        ))}
      </div>
      <div className="homepage-gallery-seemore"><a href="/Gallery">See More</a></div>
      <GalleryModal open={modalOpen} src={modalImg} onClose={() => setModalOpen(false)} />
    </section>
  );
};

export default GallerySection; 